export function getActiveHash() {
  const activeHash = localStorage.getItem('active_hash');
  return activeHash;
}

export function setContractStorage(hcode) {
  localStorage.setItem('selectedContract', hcode);
}

export function getStoredContract() {
  const hcode = localStorage.getItem('selectedContract');
  return hcode;
}

export function setMenuOrigin(menuType) {
  localStorage.setItem('menuType', menuType);
}

export function getMenuOrigin() {
  const menuType = localStorage.getItem('menuType');
  return menuType;
}
export function getAuthorizationMethod() {
  return localStorage.getItem('authorization_method');
}
